import {getFromTemplate} from '../base/utils';
import axios from 'axios';

class Archive {
    constructor(options) {
        const defaults = {
            $filter: document.querySelector('.js-archive-filter'),
            $results: document.querySelector('.js-archive-results'),
            $itemTemplate: document.querySelector('.js-archive-template'),
            $noResultsTemplate: document.querySelector('.js-archive-no-results-template'),
            $errorTemplate: document.querySelector('.js-archive-error-template'),
            parse: null,
            validate: null
        };
        this.params = Object.assign(defaults, options);

        if (!(this.params.$results && this.params.$results && this.params.$itemTemplate && this.params.$noResultsTemplate))
            return;

        this.$filter = this.params.$filter;
        this.$results = this.params.$results;
        this.itemTemplate = this.params.$itemTemplate.innerHTML;
        this.noResultsTemplate = this.params.$noResultsTemplate.innerHTML;
        this.errorTemplate = this.params.$errorTemplate.innerHTML;

        this.init();
    }

    validate($fields) {
        let isOK = true;

        for (let $el of $fields) {
            let $field = $el.closest('.field');

            isOK = isOK && !!$el.value;

            if (!!$el.value) {
                $field.classList.remove('error');
            } else {
                $field.classList.add('error');
            }
        }

        return isOK;
    }

    init() {
        this.$fields = this.$filter.querySelectorAll('input, select');
        this.url = this.$filter.dataset.url;

        this.$filter.addEventListener('submit', e => {
            e.preventDefault();

            this.$results.innerHTML = '<div class="loader"></div>';

            let isOK = this.validate(this.$fields);

            if (typeof this.params.validate === 'function') {
                isOK = isOK && this.params.validate(this.$fields);
            }

            if (isOK) {
                this.find();
            } else {
                this.$results.innerHTML = '';
            }
        });

        if (typeof this.params.change === 'function') {
            for (let $el of this.$fields) {
                $el.addEventListener('change', this.params.change.bind(this));
            }
        }
    }

    find() {
        let url = this.url;

        for (let $el of this.$fields) {
            url = url.replace(`[${$el.name}]`, $el.value);
        }

        axios.get(url)
            .then(data => {
                if (data.status === 200) {
                    this.display(data.data);
                }
            })
            .catch((error) => {
                console.warn(error);
                this.$results.innerHTML = '';
                this.$results.appendChild(getFromTemplate(this.errorTemplate));
            });
    }

    display(items) {
        this.$results.innerHTML = '';

        if (items.length) {
            for (let i in items) {
                if (items.hasOwnProperty(i)) {
                    this.$results.appendChild(this.renderItem(items[i]));
                }
            }
        } else {
            this.$results.appendChild(getFromTemplate(this.noResultsTemplate));
        }
    }

    renderItem(itemData) {
        let itemHtml = this.itemTemplate,
            $item;

        for (let param in itemData) {
            if (itemData.hasOwnProperty(param)) {
                itemHtml = itemHtml.replace(`[${param}]`, itemData[param]);
            }
        }

        $item = getFromTemplate(itemHtml);

        if (typeof this.params.parse === 'function') {
            this.params.parse($item, itemData);
        }

        return $item;
    }
}

export default Archive;
